module.exports = __webpack_public_path__ + "img/v_0.ae1a0afe.png";